import axios from 'axios';
import { OMNIAPI } from '../../constants/urls';

/**
 *  获取omni数据
 * @param {*} postion 分发位置
 * @returns
 */
export function getOmniData(postion) {
  return axios
    .get(`${OMNIAPI}/get_position_data`, {
      params: {
        param: JSON.stringify({
          lang: 'zh-Hans',
          positions: [
            {
              position: postion,
              dataSources: []
            }
          ]
        }),
        format: ''
      }
    })
    .then(res => {
      if (!res?.data?.data) {
        return Promise.reject(new Error('获取活动列表失败'));
      }
      return res.data.data?.[postion];
    });
}
